import { PssApi } from '../pss-api/pss-api.service';
export class ConfigService extends PssApi {
    constructor() {
        super(...arguments);
        this.config = async (params) => {
            const response = await this.pssApi.get('/api/configuration', {
                params
            });
            return response.data;
        };
        this.versions = async () => {
            const response = await this.pssApi.get('/api/configuration/versions');
            return response.data;
        };
        this.subsetVersions = async (subsetName, mainConfigVersion = null) => {
            const response = await this.pssApi.get('/api/subsets', {
                params: { subsetName, configVersion: mainConfigVersion }
            });
            return this.mapSubsetVersions(response.data);
        };
        this.mapSubsetVersions = (subsetsData) => subsetsData.map((data) => {
            const subsetVersion = JSON.parse(data.version);
            return `${subsetVersion.major}.${subsetVersion.minor}.${subsetVersion.patch}`;
        });
    }
}
//# sourceMappingURL=config.service.js.map